import { Box, HStack, Spinner, Stack, Tag, TagLabel, Text } from "@chakra-ui/react";

import { ContactToImport, STATUS } from "@components/Import/types";

interface ContactImportCardProps {
    contact: ContactToImport;
    bgColor: string;
}

export const ContactImportCard = (props: ContactImportCardProps) => {
    const { contact, bgColor } = props;
    const isImporting = contact.status === "importing";
    const isExcluded = contact.status === "excluded";

    const config = STATUS[contact.status];
    const bg = isExcluded ? "CSFBlue.200" : (isImporting ? "CSFBlue.800" : bgColor);
    const reason = contact.note ?? config.subLabel;

    const renderTag = () =>  {
        return (
            <Tag variant="outline" boxShadow="none" size="sm" px={3} py={1} borderRadius="full" color={config.color} border="1px solid" borderColor={config.color}>
                {isImporting ? 
                    <HStack spacing={1.5}>
                        <Spinner size="xs" thickness="2px" speed="1s" />
                        <Text fontSize="xs">{isImporting ? "En cours" : config.label}</Text>
                    </HStack>
                    : 
                    <TagLabel fontSize="xs" color={config.color} fontWeight="600">
                        {config.label}
                    </TagLabel>
                }
            </Tag>
    )};

    return (
        <Box p={3} borderRadius="md" border="1px solid" borderColor="gray.100" backgroundColor={bg}>
            <HStack justify="space-between" align="flex-start" spacing={2}>
                <Stack spacing={0.5} flex="1" minW={0}>
                    <Text fontWeight="bold" color="gray.300" noOfLines={1}>
                        {contact.data.lastName} {contact.data.firstName || ""}
                    </Text>
                    <Text fontSize="sm" color="gray.400" noOfLines={1}>
                        {contact.data.email.length !== 0 ? contact.data.email : "—"}
                    </Text>
                    <Text fontSize="sm" color="gray.400">
                        Tél: {contact.data.phone || "—"}
                    </Text>
                </Stack>

               { renderTag() }
            </HStack>

            {reason && !isImporting && (
                <HStack spacing={1.5} mt={2}>
                    <Text fontSize="xs" color={config.color}>
                        Raison: {reason}
                    </Text>
                </HStack>
            )}
        </Box>
    );
}